module.exports = __webpack_public_path__ + "static/media/logo-chatbot.496046d4.png";